import Icon, { OptionalIconProps } from './Icon';

export default function Spinner({ displayed = true, ...rest }: SpinnerProps) {
  if (!displayed) {
    return null;
  }

  return <Icon icon="cog" spin {...rest} />;
}

export interface SpinnerProps extends OptionalIconProps {
  displayed?: boolean;
}
